import { SvgIconProps } from '@mui/material';
import Image from 'assets/images/img-garlic-bread.jpg';

const GarlicBread = ({ height = '135', width = '138', className }: SvgIconProps) => (
  <svg viewBox="0 -25 138 135" width={width} height={height} fill="none" className={className}>
    <path
      d="M6.372 61.694C-.902 49.949-2.31 34.392 4.032 21.565c1.713-3.463 4.34-6.39 7.03-9.176 3.232-3.35 6.66-6.605 10.755-8.836C31.121-1.52 46.854-.244 56.821 1.765c49.615 10.01 39.265 96.39-13.28 84.027-9.211-2.168-17.555-6.979-25.499-12.092-4.777-3.078-8.71-7.226-11.67-12.006Z"
      fill="url(#Vector_svg__a)"
    />
    <defs>
      <pattern id="Vector_svg__a" patternContentUnits="objectBoundingBox" width={1} height={1}>
        <use xlinkHref="#Vector_svg__b" transform="matrix(.00026 0 0 .00026 0 -.504)" />
      </pattern>
      <image id="Vector_svg__b" width={3840} height={5760} xlinkHref={Image} />
    </defs>
  </svg>
);

export default GarlicBread;
